import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import { CommandType } from '@ispm/shared/bpmn-io/bpmn-js';
import { isANode } from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/command-interceptor-utils';
import { OverlayUtils } from '@ispm-client/modules/bpmn-modeler/bpmn/utils/overlay-utils';

/**
 * Created By Elia Rohana on 6/12/19
 */

export class NodeVisibilityBehavior extends CommandInterceptor {

    constructor(eventBus: EventBus, protected overlays) {
        super(eventBus);
        super.postExecuted([CommandType.SET_ELEMENT_VISIBILITY], isANode(this.handleOverlaysVisibility.bind(this)));
    }

    public handleOverlaysVisibility(event) {
        const context = event.context;
        const hidden = context.hidden;
        const element = context.element;
        const overlays = this.overlays.get({ element: element.id});
        overlays.forEach(overlay => {
            OverlayUtils.setVisible(overlay, !hidden);
        });
    }
}

NodeVisibilityBehavior.$inject = [...CommandInterceptor.$inject, 'overlays'];
